export enum NotificationType {
  success,
  failure,
}
